import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from "react";
import { api } from "./api";
import type { Me } from "./types";

interface AuthState { ready: boolean; user: Me | null; needsSetup: boolean; setUser(u: Me | null): void; refresh(): Promise<void>; logout(): Promise<void> }
const Ctx = createContext<AuthState>(null!);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);
  const [user, setUser] = useState<Me | null>(null);
  const [needsSetup, setNeedsSetup] = useState(false);
  const refresh = useCallback(async () => {
    try {
      const s = await api<{ needsSetup: boolean; user: Me | null }>("/auth/status");
      setUser(s.user); setNeedsSetup(s.needsSetup);
    } finally { setReady(true); }
  }, []);
  const logout = useCallback(async () => { await api("/auth/logout", { method: "POST" }); setUser(null); }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <Ctx.Provider value={{ ready, user, needsSetup, setUser, refresh, logout }}>{children}</Ctx.Provider>;
}
export const useAuth = () => useContext(Ctx);
